import { useTheme } from '@mui/material';

interface OfflineIllustrationProps {
  width?: number | string;
  height?: number | string;
}

const OfflineIllustration = ({ width = 213, height = 129 }: OfflineIllustrationProps) => {
  const { palette } = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 213 129"
      fill="none"
      style={{ display: 'block' }}
    >
      <path
        d="M134.125 15.5703H110.875C108.735 15.5703 107 17.1053 107 18.9989V20.1417C107 22.0353 108.735 23.5703 110.875 23.5703H134.125C136.265 23.5703 138 22.0353 138 20.1417V18.9989C138 17.1053 136.265 15.5703 134.125 15.5703Z"
        fill={palette.divider}
      />
      <path
        d="M134.125 48.5703H110.875C108.735 48.5703 107 50.1053 107 51.9989V53.1417C107 55.0353 108.735 56.5703 110.875 56.5703H134.125C136.265 56.5703 138 55.0353 138 53.1417V51.9989C138 50.1053 136.265 48.5703 134.125 48.5703Z"
        fill={palette.divider}
      />
      <path
        d="M51.4444 5H17.5556C10.069 5 4 11.0047 4 18.4118V67.5882C4 74.9953 10.069 81 17.5556 81H51.4444C58.931 81 65 74.9953 65 67.5882V18.4118C65 11.0047 58.931 5 51.4444 5Z"
        fill={palette.divider}
      />
      <path
        d="M49.6984 2H15.6281C8.10151 2 2 8.10151 2 15.6281V65.5978C2 73.1244 8.10151 79.2259 15.6281 79.2259H49.6984C57.225 79.2259 63.3265 73.1244 63.3265 65.5978V15.6281C63.3265 8.10151 57.225 2 49.6984 2Z"
        fill={palette.background.paper}
        stroke={palette.accent.main}
      />
      <path
        d="M25.8492 29.2559H22.4421C21.1877 29.2559 20.1708 30.2728 20.1708 31.5272V49.698C20.1708 50.9524 21.1877 51.9694 22.4421 51.9694H25.8492C27.1036 51.9694 28.1205 50.9524 28.1205 49.698V31.5272C28.1205 30.2728 27.1036 29.2559 25.8492 29.2559Z"
        fill={palette.divider}
      />
      <path
        d="M44.0201 29.2559H40.613C39.3586 29.2559 38.3417 30.2728 38.3417 31.5272V49.698C38.3417 50.9524 39.3586 51.9694 40.613 51.9694H44.0201C45.2745 51.9694 46.2914 50.9524 46.2914 49.698V31.5272C46.2914 30.2728 45.2745 29.2559 44.0201 29.2559Z"
        fill={palette.divider}
      />
      <path
        d="M178.884 4H149.357C143.085 4 138 9.08459 138 15.3568V60.7838C138 67.0559 143.085 72.1405 149.357 72.1405H178.884C185.156 72.1405 190.241 67.0559 190.241 60.7838V15.3568C190.241 9.08459 185.156 4 178.884 4Z"
        fill={palette.divider}
      />
      <path
        d="M189 36C216.256 36 216.256 74.613 198.085 83.6984"
        stroke={palette.accent.main}
        strokeLinecap="round"
      />
      <path
        d="M176.894 2H147.366C141.094 2 136.01 7.08459 136.01 13.3568V58.7838C136.01 65.0559 141.094 70.1405 147.366 70.1405H176.894C183.166 70.1405 188.251 65.0559 188.251 58.7838V13.3568C188.251 7.08459 183.166 2 176.894 2Z"
        fill={palette.background.paper}
        stroke={palette.accent.main}
      />
      <path
        d="M75 22.4411L86.3568 17.8984M75 61.0541L86.3568 65.5968M80.6784 41.7476H93.1708"
        stroke={palette.accent.main}
        strokeLinecap="round"
      />
      <path
        d="M99.5 127C144.511 127 181 120.956 181 113.5C181 106.044 144.511 100 99.5 100C54.4888 100 18 106.044 18 113.5C18 120.956 54.4888 127 99.5 127Z"
        stroke={palette.text.tertiary}
        strokeWidth="2.1817"
        strokeLinecap="round"
        strokeDasharray="0.5 8"
      />
    </svg>
  );
};

export default OfflineIllustration;
